import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../../assets/sessions/common/down-arrow.png'


const _hoisted_1 = { class: "nav-header nav-divider" }
const _hoisted_2 = { class: "nav-item-content" }
const _hoisted_3 = {
  key: 0,
  class: "nav-arrow back-arrow",
  src: _imports_0,
  alt: "#"
}
const _hoisted_4 = { class: "nav-item-image-container" }
const _hoisted_5 = ["src", "name"]
const _hoisted_6 = ["onClick", "data-test"]
const _hoisted_7 = { class: "nav-item-content" }
const _hoisted_8 = { class: "nav-item-image-container" }
const _hoisted_9 = ["src", "name", "data-test", "alt"]
const _hoisted_10 = {
  key: 1,
  class: "nav-item-bullet"
}
const _hoisted_11 = ["data-test"]
const _hoisted_12 = {
  key: 0,
  class: "nav-arrow",
  src: _imports_0,
  alt: "#"
}

import { computed } from "vue";
import { CmsResourceRelationship } from "../../../services/cms/cms-type-definitions";
import { Menu, SideNavSection } from "./side-nav.types";
import { isSectionActive, navigateTo } from "./side-nav.utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'side-nav-menu',
  props: {
    sideNavIsOpen: { type: Boolean },
    isHomeMenu: { type: Boolean, default: false },
    isHiddenLeft: { type: Boolean, default: false },
    menuData: {},
    windowHeight: {}
  },
  setup(__props: any) {

const props = __props;

const activeSection = computed(() => {
  const items = props.menuData?.items as any[] | undefined;
  if (!items) {
    return null;
  }
  const result = items.reduce(
    (previousValue: { priority: number; item: any }, currentValue) => {
      const value = currentValue as any;
      const gotNewValue =
        !!value.activePaths &&
        isSectionActive(value.activePaths) &&
        typeof value.activePriority === "number" &&
        value.activePriority < previousValue.priority;
      return gotNewValue ? { priority: value.activePriority, item: currentValue } : previousValue;
    },
    { priority: 9999, item: null },
  ).item;
  return result || null;
});

function isActiveSection(item: SideNavSection): boolean {
  return item === activeSection.value;
}

function handleLinkClick(route: string | CmsResourceRelationship): void {
  if (!route) return;
  navigateTo(route);
}

function itemHasImage(item: SideNavSection): boolean {
  return !!item.imageUrl || !!item.navOpenImage || !!item.navClosedImage;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav-menu-container", {
      'is-open': _ctx.menuData.isOpen,
      'is-hidden-left': _ctx.menuData.isHiddenLeft,
      'nested-menu': _ctx.menuData.name !== 'Home',
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "header-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menuData.name !== 'Home' ? _ctx.$emit('close-menu') : handleLinkClick(_ctx.menuData.link))),
        type: "button"
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.menuData.name !== 'Home')
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "header-image",
              src: _ctx.menuData.navOpenImage || _ctx.menuData.imageUrl,
              name: _ctx.menuData.name,
              alt: "menu icon"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.menuData.name), 1)
        ])
      ])
    ]),
    _createElementVNode("ul", {
      class: "nav-items",
      style: _normalizeStyle({ height: `${_ctx.windowHeight - 51}px` }),
      onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('open-nav'))),
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('open-nav')))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuData.items, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.name,
          class: _normalizeClass({
          'settings': item.name === 'Settings',
          'is-active': isActiveSection(item),
          'nav-divider': item.divider,
          'has-no-items': !item.items,
        })
        }, [
          _createElementVNode("button", {
            onClick: ($event: any) => (
            !!item.link
              ? handleLinkClick(item.link)
              : _ctx.$emit('open-menu', {
                  menuToOpenName: item.name,
                  hideMenu: _ctx.menuData.name,
                })
          ),
            "data-test": `nav-item-button-${item.name}`,
            type: "button"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (itemHasImage(item))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass({
                  'team-image-container team-image-container-sm':
                    _ctx.menuData.name === 'My Teams' && item.name !== 'Setup a team',
                })
                    }, [
                      _createElementVNode("img", {
                        class: _normalizeClass(["nav-item-image", {
                    'circle-image':
                      _ctx.menuData.name === 'Team Insights Pathway' ||
                      _ctx.menuData.name === '9 Questions Team Pathways',
                  }]),
                        src: 
                    _ctx.sideNavIsOpen
                      ? item.navOpenImage || item.imageUrl
                      : item.navClosedImage || item.imageUrl
                  ,
                        name: item.name,
                        "data-test": `nav-item-img-${item.name}`,
                        alt: item.name
                      }, null, 10, _hoisted_9)
                    ], 2))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10))
              ]),
              _createElementVNode("span", {
                "data-test": `nav-item-title-${item.name}`
              }, _toDisplayString(item.name), 9, _hoisted_11),
              (!!item.items)
                ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_6)
        ], 2))
      }), 128))
    ], 36)
  ], 2))
}
}

})